import styled, { css } from "styled-components"
import { Link } from "gatsby"

export const PostItemsStyles = styled.section`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: clamp(0.9rem, 1.5vw, 1.25rem);
`

const cardBase = css`
  flex: 0 0 100%;
  display: flex;
  flex-direction: column;
  background: var(--color-panel);
  border: 1px solid var(--color-line);
  border-radius: 16px;
  padding: 28px 24px;
  color: var(--color-paper);
  text-decoration: none;
  transition: border-color 0.5s var(--ease-power),
    transform 0.5s var(--ease-power), box-shadow 0.5s var(--ease-power);

  @media (min-width: 768px) {
    flex-basis: calc(50% - 20px);
    padding: 34px 30px;
  }

  @media (min-width: 1024px) {
    flex-basis: calc(33.333% - 27px);
    padding: 44px 38px;
  }

  .card__index {
    display: block;
    font-family: var(--font-display);
    font-weight: 600;
    font-size: 1.9rem;
    line-height: 1;
    color: var(--color-gold-500);
    margin-bottom: 1.4rem;
  }

  h4 {
    margin: 0 0 0.85rem;
  }

  p {
    font-size: var(--p);
    margin: 0;
    color: var(--color-ash);
  }

  &:hover {
    border-color: var(--color-gold-700);
  }
`

// informational card (no destination)
export const PostItemCard = styled.article`
  ${cardBase}
`

// linked card — lifts + glows on hover
export const PostItemLink = styled(Link)`
  ${cardBase}
  color: var(--color-paper);

  &:hover {
    color: var(--color-paper);
    transform: translateY(-4px);
    box-shadow: 0 22px 50px -26px rgba(0, 0, 0, 0.85),
      0 0 0 1px rgba(231, 163, 56, 0.1);
  }
`
